"use client";

import { useState, useCallback } from "react";
import TasksPage from "./TasksPage";
import TasksProjectPage from "./TasksProjectPage";

type TasksView = "list" | "project";

export default function TasksShell() {
  const [view, setView] = useState<TasksView>("list");
  const [selectedProjectId, setSelectedProjectId] = useState<string | null>(null);

  const openProject = useCallback((projectId: string) => {
    setSelectedProjectId(projectId);
    setView("project");
  }, []);

  const goBack = useCallback(() => {
    setView("list");
    setSelectedProjectId(null);
  }, []);

  return (
    <>
      {view === "list" && <TasksPage onOpenProject={openProject} />}
      {view === "project" && selectedProjectId && (
        <TasksProjectPage projectId={selectedProjectId} onBack={goBack} />
      )}
    </>
  );
}
